import { useEffect } from "react";

const Contact = () => {
  useEffect(() => {
    // Load Termly script only once
    if (!document.getElementById("termly-jssdk")) {
      const script = document.createElement("script");
      script.id = "termly-jssdk";
      script.src = "https://app.termly.io/embed-policy.min.js";
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section className="contact py-80">
      {/* Page-only styling */}
      <style>{`
        .contact h1,
        .contact h2,
        .contact h3,
        .contact h4,
        .contact h5,
        .contact h6 {
          font-size: 28px;
          margin-top: 20px;
          margin-bottom: 20px;
        }
      `}</style>

      <div className="container container-lg">
        <div className="row gy-5">
          <div className="col-lg-12">
            <div className="contact-box px-24 py-40">
              {/* 🔽 Termly Embed */}
              <div
                name="termly-embed"
                data-id="dad8fcb0-1359-4c9e-a6af-7f9f25862dce"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
